import { LineString } from 'ol/geom';
import Circle from 'ol/geom/Circle';
import GeometryCollection from 'ol/geom/GeometryCollection';
import Polygon, { fromCircle } from 'ol/geom/Polygon';
import { getUnitFactor } from '../../utils/unitConversion';

function tallyBarbs(speed) {
  // round to nearest 5
  let remainder = 5 * Math.round(speed / 5);
  let pennant = 0;
  let full = 0;
  let half = 0;

  if (remainder >= 50) {
    pennant = Math.floor(remainder / 50);
    remainder -= pennant * 50;
  }

  if (remainder >= 10) {
    full = Math.floor(remainder / 10);
    remainder -= full * 10;
  }

  if (remainder >= 5) {
    half = Math.floor(remainder / 5);
  }

  return [pennant, full, half];
}

export function drawCalm(coordinates, radius) {
  const calm = new Circle(coordinates, radius);
  return fromCircle(calm);
}

function drawPennant(coordinates, linePosition, lineGap, lineSize) {
  const line = new LineString([[coordinates[0] - linePosition + lineGap, coordinates[1]], [coordinates[0] - linePosition + lineGap * 2, coordinates[1]]]);
  const pennant = new Polygon([[[coordinates[0] - linePosition, coordinates[1]], [coordinates[0] - linePosition, coordinates[1] + lineSize], [coordinates[0] - linePosition + lineGap, coordinates[1]], [coordinates[0] - linePosition, coordinates[1]]]]);
  return [pennant, line];
}

function drawLine(coordinates, linePosition, lineGap, lineSize) {
  return new LineString([[coordinates[0] + linePosition, coordinates[1]], [coordinates[0] + linePosition - lineGap, coordinates[1] + lineSize]]);
}

function drawLineHalf(coordinates, linePosition, lineGap, lineSize) {
  return new LineString([[coordinates[0] + linePosition, coordinates[1]], [coordinates[0] + linePosition - lineGap / 2, coordinates[1] + lineSize]]);
}

export function drawBarbs({
  coordinates,
  speedKN,
  direction,
  size
}) {
  const barbNumer = tallyBarbs(speedKN); // [1, 2, 1]

  const isCalmWind = barbNumer.reduce((acc, curr) => acc + curr) === 0;
  const lineSize = size;

  if (isCalmWind) {
    return drawCalm(coordinates, lineSize / 2);
  }

  const generalLine = lineSize * 2.5;
  const lineGap = generalLine / 5;
  const startCoordinates = coordinates;
  const endCoordinates = [coordinates[0] - generalLine, coordinates[1]];
  const lineStr = new LineString([startCoordinates, endCoordinates]);
  const defaultGeometries = [lineStr];
  const geometries = barbNumer.reduce((styles, current, index, array) => {
    let linePosition = 0;

    if (index === 0) {
      let pennantPosition = 0;

      for (let i = 0; i < current; i += 1) {
        pennantPosition += lineGap * 2;
        const d = drawPennant(endCoordinates, pennantPosition, lineGap, lineSize);
        styles.push(d[0]);
        styles.push(d[1]);
      }
    }

    if (index === 1) {
      for (let i = 0; i < current; i += 1) {
        styles.push(drawLine(endCoordinates, linePosition, lineGap, lineSize));
        linePosition += lineGap;
      }
    }

    if (index === 2 && current !== 0) {
      const position = array[1] === 0 ? lineGap : lineGap * array[1];
      const lineHalfSize = lineSize / 2;
      styles.push(drawLineHalf(endCoordinates, position, lineGap, lineHalfSize));
    }

    return styles;
  }, defaultGeometries);
  const geometry = new GeometryCollection(geometries);
  geometry.rotate(direction - Math.PI / 2, startCoordinates);
  return geometry;
}
export default (({
  sizeFactor
}) => (feature, resolution, _, __, additionalOptions) => {
  const props = feature.getProperties();
  const geometry = feature.getGeometry();
  const coordinates = geometry.getCoordinates();
  const speedKN = +props.Value * getUnitFactor(additionalOptions.unit.toString().toUpperCase());
  const direction = -props.Direction * Math.PI / 180;
  const size = resolution * sizeFactor;
  return drawBarbs({
    coordinates,
    speedKN,
    direction,
    size
  });
});